import { graphql, HeadFC, type PageProps } from "gatsby";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";
import Layout from "../components/Layout";
import { useRoomDetails } from "../components/rooms/useRoomsDetails";
import AboutSection from "../sections/AboutSection";
import ClientSection from "../sections/clients/ClientSection";
import ExtraSection from "../sections/ExtraSection";
import FacilitiesSection from "../sections/facilities/FacilitiesSection";
import ReservationSection from "../sections/ReservationSection";
import RoomsSection from "../sections/RoomsSection";
import SEO, { SEOProps } from "../sections/SEO";
import SliderSection from "../sections/SliderSection";
import TestimonialsSection from "../sections/TestimonialsSection";

const IndexPage: React.FC<PageProps> = () => {
  const { t: tHome } = useTranslation("home");
  const rooms = useRoomDetails();

  return (
    <Layout>
      <SliderSection />
      <AboutSection />
      <RoomsSection
        title={tHome("section.rooms.title")}
        subtitle={tHome("section.rooms.subtitle")}
        items={rooms.map((room) => ({
          code: room.code,
          name: room.name,
          image: room.image,
          price: room.price,
          link: `/rooms/${room.code}`,
        }))}
      />
      <ExtraSection />
      <FacilitiesSection />
      <TestimonialsSection />
      <ReservationSection />
      <ClientSection />
    </Layout>
  );
};

export const Head: HeadFC<SEOProps> = ({ data, location }) => {
  const commonData = JSON.parse(
    data.locales.edges.find((edge: any) => edge.node.ns === "common")?.node?.data as any
  );
  return <SEO title={commonData.fullName} locales={data.locales as any} pathname={location.pathname} />;
};

export default IndexPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: {
        ns: { in: ["home", "contact", "rooms", "common"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
